import { render, staticRenderFns } from "./shop_hx_list.vue?vue&type=template&id=98d6d466&scoped=true"
import script from "./shop_hx_list.vue?vue&type=script&lang=js"
export * from "./shop_hx_list.vue?vue&type=script&lang=js"
import style0 from "./shop_hx_list.vue?vue&type=style&index=0&id=98d6d466&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98d6d466",
  null
  
)

export default component.exports